import React from "react";

export default function VisaIndicator({ v }) {
  let bgClass;

  switch (v) {
    case 1:
      bgClass = "bg-gradient-to-br from-orange-400 to-orange-600";
      break;
    case 2:
    case 3:
      bgClass = "bg-gradient-to-br from-green-400 to-green-600";
      break;
    case 4:
      bgClass = "bg-gradient-to-br from-red-400 to-red-600";
      break;
    default:
      bgClass = "bg-gray-300";
  }

  return (
    <span
      className={`
        inline-block w-3 h-3 rounded-full
        ${bgClass}
        opacity-80
        shadow-[0_0_6px_rgba(255,255,255,0.5)]
        hover:opacity-100
        hover:shadow-[0_0_10px_rgba(255,255,255,0.8)]
        transition-all duration-300
      `}
    ></span>
  );
}
